import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchUserFamilyMemberById } from "../../../service/UserFamilyApi";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Loading, Breadcrumbs } from "../../../components/shared";
import useCheckLoggedin from "../../../utils/useCheckLoggedin";
import { getAge } from "../../../utils/Utilities";

function FamilyMemberView() {
  useCheckLoggedin();
  const { id } = useParams();
  const navigate = useNavigate();
  const [familyMemberData, setFamilyMemberData] = useState(null);
  const [error, setError] = useState(null);

  // Fetch family data
  useEffect(() => {
    const fetchFamilyMemberData = async () => {
      try {
        if (id) {
          const data = await fetchUserFamilyMemberById(id);
          setFamilyMemberData(data); // Set the fetched data to state
        }
      } catch (error) {
        setError("Error fetching family member data");
      }
    };

    fetchFamilyMemberData();
  }, [id]);

  if (error) {
    return <div>Error: {error}</div>; // Display error message
  }

  // If data is not available, show loading
  if (!familyMemberData) {
    return (
      <>
        <Navbar />
        <div className="general_parent">
          <div className="general_container">
            <div className="general_body">
              <Breadcrumbs /><br />
              <Loading />
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <Helmet>
        <title>உறுப்பினர் விவரங்கள்</title>
        <link rel="canonical" href={`/family/member-view`} />
      </Helmet>

      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs /><br />
            <h3>உறுப்பினர் விவரங்கள்</h3>
            <br />
            <div className="details-card">
              {/* Aadhar Number */}
              <div className="detail-item">
                <span className="detail-label">ஆதார் எண்:</span>
                <span style={{ color: familyMemberData.familyMember.aadhar?.startsWith("TMP") ? "red" : "inherit" }}>
                  {(familyMemberData.familyMember.aadhar || "இல்லை").replace(/^TMP/, "")}
                </span>

              </div>

              {/* First Name */}
              <div className="detail-item">
                <span className="detail-label">பெயர்:</span>
                <span>{familyMemberData.familyMember.firstName || ""}</span>
              </div>

              {/* Last Name */}
              <div className="detail-item">
                <span className="detail-label">தந்தை / கணவர் பெயர்:</span>
                <span>{familyMemberData.familyMember.lastName || ""}</span>
              </div>


              {/* Business Name */}
              <div className="detail-item">
                <span className="detail-label">வணிக பெயர்:</span>
                <span>{familyMemberData.familyMember.businessName || ""}</span>
              </div>

              {/* Date of Birth */}
              <div className="detail-item">
                <span className="detail-label">பிறந்த தேதி:</span>
                <span>
                  {familyMemberData.familyMember.dob
                    ? new Date(familyMemberData.familyMember.dob).toLocaleDateString("ta-IN", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })
                    : ""}
                  {familyMemberData.familyMember.dob ? ` (வயது: ${getAge(familyMemberData.familyMember.dob)})` : ""}
                </span>
              </div>


              {/* Mobile Numbers */}
              <div className="detail-item">
                <span className="detail-label">கைபேசி எண்:</span>
                <span>{familyMemberData.familyMember.mobile || ""}</span>
              </div>

              <div className="detail-item">
                <span className="detail-label">கைபேசி எண் 2:</span>
                <span>{familyMemberData.familyMember.mobile2 || ""}</span>
              </div>

              {/* Email */}
              <div className="detail-item">
                <span className="detail-label">மின்னஞ்சல்:</span>
                <span>{familyMemberData.familyMember.email || ""}</span>
              </div>

              <div className="detail-item">
                <span className="detail-label">நிலை:</span>
                <span style={{ color: ["draft", "inactive", 'pending'].includes(familyMemberData.familyMember.status) ? "red" : "inherit" }}>
                  {familyMemberData.familyMember.status || ""}
                </span>

              </div>

              <button onClick={() => navigate(`/user/family/member-update/${familyMemberData.familyMember.id}`)}>உறுப்பினரை திருத்து</button>
              <br />
              <button onClick={() => navigate(`/user/family/view/${familyMemberData.familyMember.familyId}`)}>குடும்பத்தைப் பார்</button>

            </div>
            <br />
            <button onClick={() => navigate("/user/profile")}>என் கணக்கிற்குச் செல்</button>
          </div>

        </div>
      </div>

      <Footer />
    </>
  );
}

export default FamilyMemberView;
